import { Component } from '@angular/core'
import { LanguageService } from '@localization-lib/language/language.service'
import { Language } from '@localization-lib/language/models/Language'
import { UpdatesService } from '@platform-lib/updates/updates.service'
import { sortUpdates } from '@platform-lib/updates/util/sortUpdates'
import { isTruthy } from '@util-lib/isTruthy'
import { processHttpResponse } from '@util-lib/processHttpResponse'
import { combineLatest } from 'rxjs'
import { filter, map, shareReplay } from 'rxjs/operators'

@Component({
    selector: 'app-updates',
    styleUrls: ['./updates.component.scss'],
    templateUrl: './updates.component.html',
})
export class UpdatesComponent {
    constructor(
        private updatesService: UpdatesService,
        private languageService: LanguageService
    ) {}

    updatesResponse$ = this.updatesService
        .getUpdates()
        .pipe(processHttpResponse(), shareReplay(1))

    updates$ = this.updatesResponse$.pipe(
        map(({ data }) => data),
        filter(isTruthy),
        filter((updates) => updates.length > 0),
        map((updates) => sortUpdates(updates))
    )

    loading$ = this.updatesResponse$.pipe(map((response) => response.loading))

    error$ = this.updatesResponse$.pipe(map((response) => response.error))

    firstUpdate$ = this.updates$.pipe(map((updates) => updates[0]))

    otherUpdates$ = this.updates$.pipe(map((updates) => updates.slice(1)))

    language$ = this.languageService.selectedLanguage$

    updateData$ = combineLatest([
        this.firstUpdate$,
        this.otherUpdates$,
        this.language$,
    ]).pipe(
        map(([firstUpdate, otherUpdates, language]) => ({
            firstUpdate: {
                ...firstUpdate,
                headline:
                    language === Language.DE
                        ? firstUpdate.headline.de
                        : firstUpdate.headline.en,
                overview:
                    language === Language.DE
                        ? firstUpdate.overview.de
                        : firstUpdate.overview.en,
            },
            otherUpdates: otherUpdates.map((otherUpdate) => ({
                ...otherUpdate,
                headline:
                    language === Language.DE
                        ? otherUpdate.headline.de
                        : otherUpdate.headline.en,
                overview:
                    language === Language.DE
                        ? otherUpdate.overview.de
                        : otherUpdate.overview.en,
            })),
        }))
    )
}
